import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getCollectionBySlugRequest = {};
var _getCollectionBySlugResponse = {};
var _getCollectionRequest = {};
var _getCollectionResponse = {};
var _queryCollectionsRequest = {};
var _queryCollectionsResponse = {};
function resolveWixCatalogApiV2CollectionReadApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores-reader/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/stores-reader/v2/inventoryItems',
                destPath: '/v2/inventoryItems',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-ecommerce-catalog-reader-web',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 */
export function queryCollections(payload) {
    var _a = serializer(_queryCollectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCollectionsResponse, {}).fromJSON;
    function __queryCollections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.collection',
            method: 'POST',
            methodFqn: 'wix.catalog.api.v2.CollectionReadApi.QueryCollections',
            url: resolveWixCatalogApiV2CollectionReadApiUrl({
                protoPath: '/v2/collections/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixCatalogApiV2CollectionReadApiUrl({
                        protoPath: '/v2/collections/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryCollections.fromReq = fromReq;
    __queryCollections.__isAmbassador = true;
    return __queryCollections;
}
/** Retrieves a collection with the provided ID. */
export function getCollection(payload) {
    var _a = serializer(_getCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCollectionResponse, {}).fromJSON;
    function __getCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.collection',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v2.CollectionReadApi.GetCollection',
            url: resolveWixCatalogApiV2CollectionReadApiUrl({
                protoPath: '/v2/collections/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCollection.fromReq = fromReq;
    __getCollection.__isAmbassador = true;
    return __getCollection;
}
/** Retrieves a collection with the provided slug. */
export function getCollectionBySlug(payload) {
    var _a = serializer(_getCollectionBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCollectionBySlugResponse, {}).fromJSON;
    function __getCollectionBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.catalog.v1.collection',
            method: 'GET',
            methodFqn: 'wix.catalog.api.v2.CollectionReadApi.GetCollectionBySlug',
            url: resolveWixCatalogApiV2CollectionReadApiUrl({
                protoPath: '/v2/collections/slug/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCollectionBySlug.fromReq = fromReq;
    __getCollectionBySlug.__isAmbassador = true;
    return __getCollectionBySlug;
}
//# sourceMappingURL=http.impl.js.map